module.exports = __webpack_public_path__ + "img/4064008370.9de5d01a.jpg";